import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { catalogBibShape } from '@bibliocommons/bc-prop-types';
import { selectAgeSuitabilitiesTransactions } from 'app/selectors/ugc/AgeSuitabilitiesSelector';
import AgeSuitabilitiesActions from 'app/actions/AgeSuitabilitiesActions';
import ModalActions from 'app/actions/ModalActions';
import { getIsLoadingFromUgcTransactions } from 'app/helpers/bib/bibHelpers';
import DeleteAgeRatingModal from './DeleteAgeRatingModal';

export function DeleteAgeRatingModalContainer(props) {
  return <DeleteAgeRatingModal {...props} />;
}

DeleteAgeRatingModalContainer.propTypes = {
  // ownProps
  ageSuitabilityId: PropTypes.number.isRequired,
  catalogBib: catalogBibShape.isRequired,
  handleSuccess: PropTypes.func,

  // Redux props
  ageSuitabilitiesActions: PropTypes.objectOf(PropTypes.func).isRequired,
  isLoading: PropTypes.bool.isRequired,
  modalActions: PropTypes.objectOf(PropTypes.func).isRequired
};

const mapStateToProps = (state, ownProps) => ({
  isLoading: getIsLoadingFromUgcTransactions(
    selectAgeSuitabilitiesTransactions(state),
    ownProps.catalogBib.get('metadataId'),
    ownProps.ageSuitabilityId
  )
});

const mapDispatchToProps = dispatch => ({
  ageSuitabilitiesActions: bindActionCreators(AgeSuitabilitiesActions, dispatch),
  modalActions: bindActionCreators(ModalActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(DeleteAgeRatingModalContainer);
